export default [
  { title: "Home", text: "Home" },
  { title: "About", text: "About" },
  { title: "Contact", text: "Contact" },
  { title: "Dog", text: "LostBoard" },
  { title: "Submit", text: "Submit" },
];
